import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

const InfoWrapper = styled('p')(({ theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginRight: 'auto',
  color: theme.palette.text.secondary,
  display: 'inline-flex',
  alignItems: 'center',
  '.MuiSvgIcon-root': {
    marginRight: 6,
    width: 20,
    height: 20,
  },
  em: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontStyle: 'normal',
  },
  [mediaQuery(740)]: {
    marginBottom: 16,
    minWidth: '100%',
  },
}));

export default InfoWrapper;
